export default (function (route, id) {
    if (id === void 0) { id = {}; }
    var url = route;
    var params = typeof id === 'object' ? id : { id: id };
    Object.keys(params).forEach(function (property) {
        url = url.replace(":".concat(property), params[property]);
    });
    return url;
});
